import { FIND_REJECTED_PARENT_TRANSACTION} from "../../routes";
import customAxios from "../../customAxios";
import { IFindApproveParentTransaction } from "../../../types/common.interface";

async function findRejectedParentTransaction(props: IFindApproveParentTransaction) {
  var thisUrl = FIND_REJECTED_PARENT_TRANSACTION;
  let page= 1;
  let limit= 10;
  if (props.page) page=props.page;
  if (props.limit) limit=props.limit;

  let body: any = {
   ...props, page,limit
  };

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({FIND_PAY_ADMIN_TO_DRIVER: error});
  }
}

export default findRejectedParentTransaction;
